interface PageTitleProps {
  title: string;
  subtitle?: string;
  /** `page` = h1 2xl (default), `section` = h1 xl */
  size?: 'page' | 'section';
  className?: string;
}

export function PageTitle({ title, subtitle, size = 'page', className }: PageTitleProps) {
  const titleCls = size === 'page'
    ? 'font-display text-xl sm:text-2xl text-ink-900 dark:text-white'
    : 'font-display text-xl text-ink-900 dark:text-white';

  return (
    <div className={className ?? 'min-w-0'}>
      <h1 className={titleCls}>{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-ink-500 dark:text-muted-foreground">{subtitle}</p>}
    </div>
  );
}
